<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="categoryOperate">
        <el-button @click="handleAdd" type="primary" size="small">新增分类</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="categoryTable">
        <el-table
          ref="multipleTable"
          :data="categoryDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border>
          <el-table-column
            prop="id"
            label="序号"
            width="60">
          </el-table-column>
          <el-table-column
            prop="name"
            label="分类名称"
            width="160">
          </el-table-column>
          <el-table-column prop="storeCategoryVos" label="子分类" width="400" align="left">
            <!-- 分行显示 -->
            <template slot-scope="scope">
              <el-tag
                :key="index"
                v-for="(item,index) in scope.row.storeCategoryVos"
                closable
                :disable-transitions="false"
                @close="handleClose(item)">
                {{item.name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="insertTime"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column label="操作"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleAddChild(scope.$index, scope.row)">添加子类</el-button>
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除分类</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="修改分类"
                 :visible.sync="editDialogVisible"
                 :append-to-body=true
                 width="40%"
                 :modal=false>
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="名称:">
            <el-input v-model="controlData.name"></el-input>
          </el-form-item>
          <el-form-item label="分类图片">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_updateCategory()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加分类"
                 :visible.sync="addDialogVisible"
                 :append-to-body=true
                 width="30%"
                 :modal=false>
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="父级分类:" v-if="controlData.parent">
            <el-input :disabled="true" v-model="controlData.parent"></el-input>
          </el-form-item>
          <el-form-item label="分类名称:">
            <el-input v-model="controlData.name"></el-input>
          </el-form-item>
          <el-form-item label="分类图片">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_addCategory()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body=true
        center>
        <span>确定要删除当前一级分类吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteCategory()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getStoreAllCategory, addStoreCategory, updateStoreCategory, deleteStoreCategory, uploadFile1} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      imageUrl:null,
      fileList:[],
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      addDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      categoryDatas: [],
      cfAdminVos: []
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getList();
    }
  },
  methods: {
    handleClose(item){
      this.deleteDialogVisible = true;
      this.controlData = item;
    },
    //文件类型   101 商品图片 102 供应商营业执照  103 banner图    104商品分类logo
    uploadSectionFile(param){
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 104);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.controlData.logo = res.data;
        } else {
          Error(this, res)
        }
      })
    },
    handleChange () {
      console.log(this.status)
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this.categoryDatas = []
      this._getList()
    },
    handleAdd() {
      this.addDialogVisible = true;
      this.controlData = {};
      this.controlData.parentId = 0;
      this.controlData.logo = "";
    },
    handleAddChild(index, row) {
      this.addDialogVisible = true;
      this.controlData = {};
      this.controlData.parent = row.name;
      this.controlData.parentId = row.id;
      this.controlData.logo = "";
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.categoryDatas[index];
    },
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = this.categoryDatas[index];
      this.fileList = [];
      this.fileList.push({
        name:this.controlData.logo,
        url:this.controlData.logo
      });
      this.fileList.push()
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [ row ];
    },
    handleShowPush(row) {
      this.cfAdminVos=row.cfAdminVos;
      this.pushDialogVisible = true;
    },
    _addCategory(){
      let param = {
        name: this.controlData.name,
        parentId: this.controlData.parentId,
        logo:this.controlData.logo
      }
      loadingInstance(Loading);
      addStoreCategory(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addDialogVisible= false;
          this.fileList=[];
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _updateCategory(){
      let param = {
        id: this.controlData.id,
        name: this.controlData.name,
        parentId: this.controlData.parentId,
        logo:this.controlData.logo
      }
      loadingInstance(Loading);
      updateStoreCategory(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.editDialogVisible= false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _deleteCategory(){
      let param = {
        id: this.controlData.id
      }
      loadingInstance(Loading);
      deleteStoreCategory(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible=false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getStoreAllCategory(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.categoryDatas = res.data.records
          this.totalNum = res.data.total
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    }
  },
}
</script>
<style scoped>
.categoryOperate{
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}
.categoryTable{
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}
.categoryOperate .el-input {
  width:180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.categoryOperate .el-button {
  width:100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/store/pageCategory.vue